import React from 'react';
import { ecosystemStats } from '../data/content';
import { Accent, SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
export function StandardsSection() {
  return <section className="w-full border-y border-white/5 bg-steel-900 px-6 py-16 sm:py-20" aria-labelledby="intro-title" data-id="element-190" data-mp="ds6ctgb1u0ju">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-[1.15fr_1fr] lg:gap-16" data-id="element-191" data-mp="irame81vy0ap">
        <div data-id="element-192" data-mp="3h9ogdbjsgleg">
          <SectionHeading id="intro-title" align="left" badge="Introducing the IIIS 2026" title={<>
                Not a book. A complete <Accent data-id="element-194" data-mp="3m9u4ihqunprs">pedagogical ecosystem.</Accent>
              </>} subtitle="We distilled decades of plant-floor experience and classroom mastery into a ready-to-teach system, designed by experts for educators and aligned with ANSI, ISA-5.1 and IEEE standards." data-id="element-193" data-mp="3ha7ok0jmzvfa" />
        </div>

        <Reveal index={1} data-id="element-195" data-mp="16gbwdzqd9ji3">
          <dl className="grid grid-cols-2 gap-px overflow-hidden border border-white/[0.07] bg-white/[0.07]" data-id="element-196" data-mp="16iy5w4wti92y">
            {ecosystemStats.map(({
            value,
            label
          }) => <div key={label} className="bg-steel-850 px-6 py-7 text-center" data-id="element-197" data-mp="3qjj7xl4r4sfs">
                <dt className="sr-only" data-id="element-198" data-mp="3ln2dyaavfjus">{label}</dt>
                <dd data-id="element-199" data-mp="3gmwql6bmwjii">
                  <span className="block font-display text-4xl font-bold text-ember-400" data-id="element-200" data-mp="3gmenbpqk1513">{value}</span>
                  <span className="mt-1 block text-xs uppercase tracking-[0.16em] text-ink-400" data-id="element-201" data-mp="3ckt47mnffuig">
                    {label}
                  </span>
                </dd>
              </div>)}
          </dl>
        </Reveal>
      </div>
    </section>;
}